import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

export const toggleInputCss = css`
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  width: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;

  :checked + i {
    padding-right: 0;
    padding-left: 20px;
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5),
      inset 0 0 50px ${theme.color.green50};
    background-color: ${theme.color.white};
  }

  &:focus:not(:checked) + i {
    box-shadow: inset 0 0 1px 1px ${theme.color.turquoise70};
  }

  &:focus:checked + i {
    box-shadow: inset 0 0 1px 1px ${theme.color.turquoise70},
      inset 0 0 50px ${theme.color.green50};
  }
`

export const toggleCss = css`
  display: inline-block;
  cursor: pointer;
  padding-right: 20px;
  border-radius: 30px;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
  background-color: ${theme.color.neutral60};
  transition: all ease 0.2s;

  ::before {
    display: block;
    content: '';
    width: 24px;
    height: 24px;
    border-radius: 30px;
    background: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }
`

export const disabledToggleCss = css`
  cursor: not-allowed !important;
`
